import type { FC } from 'react';
import { useEffect, useState } from 'react';
import type { Node } from '../../../types';
import cn from '@/utils/classnames';
import useHTTP from '@/hooks/useHTTP.mjs'
import parseMap from '@/components/SoftwareMap/scripts/parseMap.mjs';
import { Spin } from 'antd';

type RoleDescProps = Pick<Node, 'id'>
 
const RoleDesc: FC<RoleDescProps> = ({ id }) => {
  const [loading, setLoading] = useState(false)
  const [descData, setDescData] = useState('')
  const http = useHTTP();
  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = () => {
    setLoading(true);
    http.get('/rulemRm/oneRulemRmRule', {
      pkid: id
    }).then((data) => {
      console.log(data)
        
        const fileIdData = data?.ruleMap && JSON.parse(data?.ruleMap)
                  ? parseMap(data?.ruleMap)[0]
                  : undefined;
        const desc = fileIdData?.data?.arName || '暂无数据'
        setDescData(desc)
        setLoading(false);
      }).catch(err => {
        setLoading(false);
      });
  };


  return <div className={cn(
    "absolute left-2 top-[72px]",
    "w-[220px] h-auto p-2 rounded-lg border-[0.5px] border-gray-300 bg-white shadow-xl"
  )}>
    {loading ? <Spin /> : descData}
  </div>
}

export default RoleDesc